import {
    getDirectusField,
} from "directus/src/operations";

export async function fetchTicketTypes() {
  try {
    const response = await getDirectusField("tickets", "type");

    const data = response.meta.options.choices.map((type) => {
      return { name: type.text, id: type.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchTicketPriority() {
    try {
        const response = await getDirectusField("tickets", "priority");

        const data = response.meta.options.choices.map((priority) => {
            return { name: priority.text, id: priority.value };
        });
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}